<template>
    <Channels v-if="!isDesktop"/>
    <div class="desktop-home" v-else>
        <DesktopHero />

        <div class="home-sections" @mouseover="onSectionsHover" @mouseleave="unlockHistorySwipe">
            <div v-if="trending.length > 0" class="home-section">
                <h2>Trending Now</h2>
                <div class="vod-scroll">
                    <Movie v-for="(media, i) in trending" :key="'trend-' + i" :media="media" :list="true" :display="true" :existingSaves="saves" />
                </div>
            </div>

            <GameParty />

            <div v-if="reccomendations.length > 0" class="home-section">
                <h2>Based on your history</h2>
                <div class="vod-scroll">
                    <div v-for="(media, i) in reccomendations" :key="'trend-' + i">
                        <Movie :media="media" :list="true" :display="true" :existingSaves="saves" />
                    </div>
                </div>
            </div>

            <div v-if="continueWatching.length > 0" class="home-section">
                <h2>Continue Watching</h2>
                <div class="vod-scroll">
                    <div v-for="(media, i) in continueWatching" :key="'trend-' + i">
                        <Movie :media="media" :list="true" :display="true" :history="true" :existingSaves="saves" />
                    </div>
                </div>
            </div>

            <div v-if="liveSports.length > 0" class="home-section">
                <div class="section-header">
                    <h2>Live Sports</h2>
                    <router-link to="/live" class="see-all" v-ripple>see all</router-link>
                </div>
                <div class="scroll-row">
                    <div v-for="(s, i) in liveSports" :key="'sport-' + i" >
                        <Sport :sport="s" v-ripple mode='live' />
                    </div>
                </div>
            </div>

            <div v-if="history.length > 0" class="home-section">
                <h2>Jump Back In</h2>
                <div class="history-grid" ref="historyGrid" :style="{ '--history-columns': historyColumns }">
                    <MixedHistory v-for="(h, i) in history.slice(0, historyItemCount)" :key="i" size="fit" :history="h" />
                </div>
            </div>

            <div v-if="guides.length > 0" class="home-section">
                <h2>What's On Now</h2>
                <div class="scroll-row">
                    <ContentGuide v-for="(g, i) in guides.slice(0, 12)" :key="i" :guide="g" />
                </div>
            </div>

            <div v-if="epgs.length > 0" class="home-section">
                <div class="section-header">
                    <h2>Program Guide</h2>
                    <router-link to="/epg" class="see-all" v-ripple>see all</router-link>
                </div>

                <div class="result-items content-row epg">
                    <template v-for="(e, i) in epgs">

                        <div class="content-row-epg-wrapper"  :key="'epg-' + i">
                            <ListGuide :guide="e" v-ripple/>
                        </div>

                    </template>
                </div>
            </div>


            <div v-if="saves.length > 0" class="home-section">
                <h2>Saved For Later</h2>
                <div class="vod-scroll">
                    <div v-for="(media, i) in saves" :key="'trend-' + i">
                        <Movie :media="media" :list="true" :display="true" :saved="true" :existingSaves="saves" />
                    </div>
                </div>
            </div>


            <div class="home-section" v-for="(v, k) in vod" :key="'vod-' + k">
                <h2 v-if="v.name">{{ v.name }}</h2>
                <div class="vod-scroll" v-if="v.name" @scroll="(e) => { if(v.mode !== 'numbered') {handleScroll(e.target, v, k)} }">
                    <div v-for="(media, i) in v.vods" :key="i" >
                        <Movie :media="media" :list="true" :display="true" :existingSaves="saves"  :number="v.mode === 'numbered' ? `${i+1}` : null"/>
                    </div>
                </div>
            </div>

            <div id="scroll-sentinel" style="height:1px"></div>
        </div>



        <Loader v-if="!ready" />
    </div>
</template>

<script>
const Channels = () => import("@/views/Channels.vue");
const MixedHistory = () => import('@/components/MixedHistory')
const ContentGuide = () => import('@/components/ContentGuide')
const ListGuide = () => import('@/components/ListGuide')
const Movie = () => import('@/components/desktop/Movie')
const Sport = () => import('@/components/Sport')
const Loader = () => import('@/components/Loader')
const DesktopHero = () => import('@/components/desktop/MovieHero')
import GameParty from '@/components/GameParty.vue'

export default {
    name: 'DesktopHome',

    components: {
        Channels,
        MixedHistory,
        ContentGuide,
        ListGuide,
        Movie,
        Sport,
        Loader,
        DesktopHero,
        GameParty
    },

    data() {
        return {
            history: [],
            odHistory: [],
            historyColumns: 5,
            historyRows: 2,
            historyItemMinWidth: 280,
            historyGridGap: 16,
            reccomendations: [],
            saves: [],
            guides: [],
            epgs: [],
            trending: [],
            vod: [],
            liveSports: [],
            ready: false,
            loading: [],
            continueWatching: [],
            activeFeature: { id: '', name: 'loading...' },
            activeGenre: { id: '', name: 'loading...' },
            activeYear: { id: '', name: 'loading...' },
            genres: window.genres,
            features: window.features,
            allQueries: [],
            currentQueryIndex: 0,
            loadingMore: false,
        }
    },

    computed: {
        historyItemCount() {
            return this.historyColumns * this.historyRows
        },
    },

    watch: {
        isDesktop(newVal) {
            if (newVal) {
                this.destroyHistoryGridObserver()
                this.$nextTick(() => this.setupHistoryGridObserver())

                this.destroyScrollObserver()
                this.$nextTick(() => this.setupScrollObserver())
            }
        },
    },

    mounted() {
        document.title = 'Stream & Play Anything - QB'
        this.activeGenre = this.genres[Math.floor(Math.random() * this.genres.length)]
        this.activeFeature = this.features[Math.floor(Math.random() * this.features.length)]
        this.activeYear = {
            id: 'year',
            name: `${Math.floor(Math.random() * (new Date().getFullYear() - 1990 + 1)) + 1990}`,
        }

            this.loadTrending()
            this.loadSports()
            this.loadHistory()
            this.loadAllMedia()
            //this.loadGuides()
            this.ready = true

        this.$root.$on('savesUpdated', () => {
            this.reloadSaves()
        })
    },

    activated() {
        document.title = 'Stream & Play Anything - QB'
        this.$nextTick(() => {
            this.setupHistoryGridObserver()
            this.setupScrollObserver()
        })
    },

    beforeDestroy() {
        this.unlockHistorySwipe()
        this.destroyScrollObserver()
        this.destroyHistoryGridObserver()
    },

    deactivated() {
        this.unlockHistorySwipe()
        this.destroyScrollObserver()
        this.destroyHistoryGridObserver()
    },

    methods: {
        onSectionsHover(e){
            const overRow = !!(e.target.closest && e.target.closest('.vod-scroll'))
            if (overRow === !!this._historySwipeLocked) return
            overRow ? this.lockHistorySwipe() : this.unlockHistorySwipe()
        },

        lockHistorySwipe(){
            this._historySwipeLocked = true
            document.documentElement.style.overscrollBehaviorX = 'none'
            document.body.style.overscrollBehaviorX = 'none'
        },

        unlockHistorySwipe(){
            if (!this._historySwipeLocked) return
            this._historySwipeLocked = false
            document.documentElement.style.overscrollBehaviorX = ''
            document.body.style.overscrollBehaviorX = ''
        },

        async reloadSaves(){
            const saved  = await window.afetch(`/save?group=od`)
            const savedRes =  await saved.json()
            this.saves = []
            this.$nextTick(() => { this.saves = savedRes.saves })
        },

        async loadHistory(){
            //local wod history
            this.continueWatching = JSON.parse(localStorage.getItem('continueWatching')) || [];

            //global wr history
            const res = await window.afetch('/history')
            const data = await res.json()
            this.history = window.shuffle(data.history)
            this.$nextTick(() => this.setupHistoryGridObserver())

            //global wr history
            const saved  = await window.afetch(`/save?group=od`)
            const savedRes =  await saved.json()
            this.odHistory = savedRes.history.reverse()
            this.saves = savedRes.saves

            //ai reccos
            this.getReccomendations()
        },

        async getReccomendations(){
            const reccos = await window.afetch('/ai-vod-reccomendations', {
                method: 'POST',
                body: JSON.stringify({
                    media: this.odHistory.map(x => x.name),
                })
            })
            const data =  await reccos.json()
            this.reccomendations = window.shuffle(data.reccomendations)
        },

        async loadGuides() {
            const res = await window.afetch('/guides')
            const data = await res.json()
            this.guides = data.guides
            this.epgs = window.shuffle(data.guides).slice(0,2)
        },

        async loadSports() {
            try {
                const res = await window.afetch('/liveSports')
                const data = await res.json()
                this.liveSports = data.live || []
            } catch (e) {
                // liveSports stays empty
            }
        },

        async loadTrending() {
            try {
                const query = 'sort_by=popularity.desc&vote_count.gte=200'
                const [movieRes, tvRes] = await Promise.all([
                    window.afetch('/discover', { method: 'POST', body: JSON.stringify({ page: 1, query, type: 'movie' }) }),
                    window.afetch('/discover', { method: 'POST', body: JSON.stringify({ page: 1, query, type: 'tv' }) }),
                ])
                const movieData = await movieRes.json()
                const tvData = await tvRes.json()
                const combined = window.shuffle([...movieData.media, ...tvData.media])
                this.trending = combined.slice(0, 10)
            } catch (e) {
                // trending stays empty
            }
        },

        async loadAllMedia() {
            this.allQueries = [
                { section: 'Popular', query: 'sort_by=popularity.desc&vote_count.gte=1000', page: 1 },
                { section: 'Critically Acclaimed', query: 'sort_by=vote_average.desc&vote_count.gte=3000', page: 1 },
                { section: 'New and Noteworthy', query: 'sort_by=primary_release_date.desc&vote_count.gte=100', page: 1 },
                { section: 'More to Love', query: 'sort_by=primary_release_date.desc&vote_average.gte=7&vote_count.gte=500', page: 1 },

                { section: 'Top 20 Movies Today', query: 'TRENDING', tv: false, page: 1, mode: 'numbered'},

                { section: 'Box Office Hits', query: 'sort_by=revenue.desc', tv: false, page: 1 },
                { section: `Best of ${this.activeGenre.name}`, query: `with_genres=${this.activeGenre.id}&sort_by=popularity.desc`, tv: false, page: 1 },
                { section: `Best of ${this.activeFeature.name}`, query: `with_people=${this.activeFeature.id}&sort_by=popularity.desc`, tv: false, page: 1 },
                { section: 'Fan Favorites', query: 'sort_by=vote_average.desc&vote_count.gte=1500', page: 1 },
                { section: 'Hidden Gems', query: 'vote_count.lte=100&vote_average.gte=7&popularity.lte=25', page: 1 },

                { section: 'Top 20 Shows Today', query: 'TRENDING', tv: true, page: 1, mode: 'numbered'},

                { section: 'Trending', query: 'sort_by=primary_release_date.desc&vote_count.gte=25', page: 1 },
                { section: 'Instant Classics', query: 'sort_by=popularity.desc&primary_release_year.lte=2010&vote_average.gte=8', tv: false, page: 1 },
                { section: `Best of ${this.activeYear.name}`, query: `primary_release_year=${this.activeYear.name}&sort_by=vote_count.desc`, tv: false, page: 1 },
            ]

            const batch = this.allQueries.slice(0, 7)
            for (const q of batch) {
                await this.loadMedia(q.section, q.query, q.page, q.tv, false, q.mode)
            }
            this.currentQueryIndex = 7
            this.$nextTick(() => this.setupScrollObserver())
        },

        async loadMedia(name, query, page, tv = true, update, mode='') {
            let media = []
            const shouldSkipMovies = mode === 'numbered' && tv

            if(!shouldSkipMovies){
                const movieresponse = await window.afetch('/discover', {
                    method: 'POST',
                    body: JSON.stringify({ page, query, type: 'movie' }),
                })
                const movieData = await movieresponse.json()
                media = [...movieData.media]
            }

            if (tv) {
                const showresponse = await window.afetch('/discover', {
                    method: 'POST',
                    body: JSON.stringify({ page, query, type: 'tv' }),
                })
                const showData = await showresponse.json()
                media = [...media, ...showData.media]
            }

            const nextMedia = mode === 'numbered' ? media : window.shuffle(media)
            if (!update) {
                this.vod.push({ name, tv, mode, page: page + 1, query, vods: nextMedia })
            } else {
                return { name, tv, mode, page: page + 1, query, vods: nextMedia }
            }
        },

        setupHistoryGridObserver() {
            const grid = this.$refs.historyGrid
            if (!grid || this._historyResizeObserver) return

            this.calculateHistoryColumns(grid)

            this._historyResizeObserver = new ResizeObserver(() => {
                this.calculateHistoryColumns(grid)
            })
            this._historyResizeObserver.observe(grid)
        },

        destroyHistoryGridObserver() {
            if (this._historyResizeObserver) {
                this._historyResizeObserver.disconnect()
                this._historyResizeObserver = null
            }
        },

        calculateHistoryColumns(grid) {
            const styles = getComputedStyle(grid)
            const paddingX = parseFloat(styles.paddingLeft || 0) + parseFloat(styles.paddingRight || 0)
            const availableWidth = grid.clientWidth - paddingX

            const columns = Math.max(
                1,
                Math.floor((availableWidth + this.historyGridGap) / (this.historyItemMinWidth + this.historyGridGap))
            )

            if (columns !== this.historyColumns) {
                this.historyColumns = columns
            }
        },

        navigateTo(path) {
            this.$router.push(path).catch(() => {})
        },

        async handleScroll(container, v, k) {
            const isAtEnd = container.scrollLeft + container.clientWidth >= (container.scrollWidth - 500)
            if (isAtEnd && !this.loading[k]) {
                this.loading[k] = true
                const newmedia = await this.loadMedia(v.name, v.query, v.page, v.tv, true)
                const section = this.vod.find(x => x.name === v.name)
                section.page = newmedia.page
                section.vods = [...section.vods, ...newmedia.vods]
                this.loading[k] = false
            }
        },

        setupScrollObserver() {
            if (this._scrollObserver) return
            const sentinel = document.getElementById('scroll-sentinel')
            if (!sentinel) return
            this._scrollObserver = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && !this.loadingMore) {
                    this.loadNextBatch()
                }
            }, { rootMargin: '400px' })
            this._scrollObserver.observe(sentinel)
        },

        destroyScrollObserver() {
            if (this._scrollObserver) {
                this._scrollObserver.disconnect()
                this._scrollObserver = null
            }
        },

        async loadNextBatch() {
            if (this.currentQueryIndex >= this.allQueries.length) return
            this.loadingMore = true
            const batch = this.allQueries.slice(this.currentQueryIndex, this.currentQueryIndex + 4)
            for (const q of batch) {
                await this.loadMedia(q.section, q.query, q.page, q.tv, false, q.mode)
            }
            this.currentQueryIndex += 4
            this.loadingMore = false
        },


    },
}
</script>

<style lang="scss" scoped>
.desktop-home {
    min-height: 100vh;
}

.home-sections {
    margin-top: -60px;
    position: relative;
    z-index: 2;
}

.home-section {
    margin-bottom: 40px;
    overflow: visible;

    h2 {
        margin: 0 0 16px 0;
        font-size: 26px;
        font-weight: 600;
        padding-left: 48px;
        color: white;
    }
}

.section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    width: calc(100% - 64px);

    h2 {
        margin: 0;
    }

    .see-all {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        text-decoration: none;

        &:hover {
            color: white;
        }
    }
}

.history-grid {
    display: grid;
    grid-template-columns: repeat(var(--history-columns, 5), 1fr);
    height: 700px;
    padding: 0 48px;
    gap: 16px;
}

.scroll-row {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 8px;
    padding-left: 48px;
}

//make component listx
.content-row.epg{
    flex-direction: column;
    width: 100%;
    overflow: visible;
    padding: 0;

    .content-row-epg-wrapper{
        padding-left: 48px;
        margin: 5px 0;
        display: flex;
        flex-grow: 1;
        overflow-x: scroll;
    }
}


.vod-scroll {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 8px;
    padding-left: 48px;
}


</style>
